export interface StateProps {
	// // state
	// _auth: {
	//     user: User;
	//     token: string;
	//     isLoggedIn: boolean;
	// };
	// _data: {
	//     home: any;
	//     phones: any;
	//     cart: Cart;
	//     item: Item3;
	//     order: Order;
	//     options: {
	//         key: string;
	//         label: string;
	//     }[];
	//     filter: any;
	//     countries: Country[];
	//     categories: Category[];
	//     filterDefault: any;
	//     activeStore: Store;
	//     location: {
	//         address: Address;
	//         option: 'delivery' | 'pickup' | 'promos' | 'dine';
	//         radius: number;
	//     };
	//     paymentOptions: any;
	//     orderStatus: any;
	//     promo_cart: any;
	//     cartDefault: any;
	//     deliveryPartners: any;
	//     favorites: Item3[];
	// };
}

export interface StoreProps {
	__auth: {
		user: User;
		token: string;
		isLoggedIn: boolean;
		favorites: Item[];
	};
	__data: {
		home: any;
		phones: any;
		cart: Cart;
		item: Item;
		order: Order;
		options: {
			key: string;
			label: string;
		}[];
		filter: any;
		settings: {
			countries: Country[];
		};
		categories: Category[];
		filterDefault: any;
		activeStore: Store;
		location: {
			address: Address;
			option: OrderTypes;
			radius: number;
		};
		paymentOptions: {
			code: string;
			label: string;
			disabled?: boolean;
		}[];
		orderStatus: Record<OrderStatus, { c: string; t: string }>;
		promo_cart: any;
		cartDefault: any;
		deliveryFees: {
			rating: number;
			amount: number;
			partner: OrderOrigins;
		}[];
		deliveryPartners: any;
		promotions: Promotion[];
		stores: Store[];
		cache: {
			user: string;
			stores: string;
		};
		is_bottom_modal: {
			is_open: boolean;
		};
	};
}

export enum OrderTypes {
	PICKUP = 'PICKUP',
	DELIVERY = 'DELIVERY',
}

export interface AxiusResponse {
	count: number;
	data: any;
	token: string;
	status: number;
	message: string;
	pay: any;
}

export interface OrdersFilter {
	status?: number;
}

export interface Category {
	id: string;
	name: string;
	createdAt: string;
	sequence: number;
	canDeliver: 0 | 1;
	updatedAt: string;
	store: string;
	price: number;
}

export interface Country {
	callingCode: string;
	code: string;
	currency: string;
	decimal: number;
	name: string;
	phoneLength: number;
}

export interface ItemDefault {
	canDeliver: number;
	createdAt: string;
	description: string;
	distance: number;
	id: string;
	images: string[];
	imagesLinks: string[];
	name: string;
	preparationTime: string;
	price: number;
	priceDiscount: number;
	status: ItemStatuses;
	updatedAt: string;
	store: Store;
	categories: Category[];
	quantity: number;
	priceTotal: number;
	code: string;
	promotion?: string;
	discount: number;
}

export enum ItemStatuses {
	DRAFT = 'DRAFT',
	PUBLISHED = 'PUBLISHED',
}

export type Item = ItemDefault & {
	variants: Variant[];
	cartItemId?: string;
};

export type ItemCart = ItemDefault & {
	variants: Record<string, Variant[]>;
	cartItemId: string;
};

export interface Variant {
	min: number;
	max: number;
	name: string;
	options: {
		code: string;
		price: number;
		name: string;
		quantity?: number;
	}[];
	price: number;
	quantity: number;
}

export interface Store {
	address: Address;
	bank: [];
	country: Country;
	code: string;
	cover: string;
	coverLink: string;
	createdAt: string;
	delivery: {
		cartMinimum: number;
		fee: number;
		feeType: string;
		options: string[];
		radius: number;
		schedule: {
			to: string;
			from: string;
		};
	};
	description: string;
	distance: number;
	email: string;
	id: string;
	logo: string;
	logoLink: string;
	name: string;
	paymentOptions: string[];
	phoneNumber: string;
	preferences: Preferences;
	schedule: Schedule[];
	slug: string;
	status: string;
	updatedAt: string;
}

export interface Schedule {
	available: boolean;
	closing: string;
	day: string;
	opening: string;
}

export interface Address {
	x: number;
	y: number;
	id?: string;
	iso: string;
	name: string;
	state: string;
	zoom: number;
	address?: string;
	timeZone: string;
	city: string;
	street: string;
	country: string;
	houseNo: string;
}

export interface Order {
	id: number;
	uuid: string;
	address: Address;
	amount: {
		total: number;
		amount: number;
		discount: number;
		delivery: number;
	};
	cancellation: {
		reason: string;
	};
	code: string;
	createdAt: any;
	delivery: {
		channel: string;
		instructions: string;
	};
	items: Item[];
	origin: string;
	paymentToken: string;
	paymentType: OrderPaymentTypes;
	reviews: {
		id: string;
		comment: string;
		deliveryChannel: string;
		deliveryRate: number;
		mealRate: number;
	}[];
	status: OrderStatus;
	statusHistory: Record<string, OrderStatus>;
	type: OrderTypes;
	updatedAt: string;
	user: User;
	riders: User[];
	store: Store;
}

export enum OrderStatus {
	new = 'NEW',
	accepted = 'ACCEPTED',
	preparing = 'PREPARING',
	completed = 'COMPLETED',
	rejected = 'REJECTED',
	cancelled = 'CANCELLED',
	timeout = 'TIMEOUT',
	delivery = 'DELIVERY',
	payment = 'PAYMENT',
	ready = 'READY',
	arrived = 'ARRIVED',
	pickup = 'PICKUP',
	unclaimed = 'UNCLAIMED',
	rider_pending = 'RIDER_PENDING',
	rider_unavailable = 'RIDER_UNAVAILABLE',
}

export interface User {
	address: Address | Address[];
	avatar: string;
	avatarLink: string;
	birthDate: string;
	country: Country;
	createdAt: string;
	email: string;
	firstName: string;
	gender: UserGenders;
	id: string;
	lastName: string;
	name: any;
	phoneNumber: string;
	preferences: {
		kyc: string[];
		isLoggedIn: boolean;
		isFirstTime: boolean;
	};
	role: any;
	status: string;
	subscription: any;
	type: string;
	updatedAt: string;
	wallet: number;
}

export enum UserGenders {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export interface Cart {
	id: string;
	delivery: {
		code?: string;
		channel: string;
		instructions?: string;
	};
	deliveryFee: number;
	items: ItemCart[];
	paymentType: OrderPaymentTypes;
	store: Store;
	promotions: string[];
	voucher: string;
	discount: number;
}

export interface Preferences {
	online: boolean;
	offlineFor: number;
	offlineAt: string;
	itemsAvailable: string[];
	sidesAvailable: string[];
	canTakeOrders: boolean;
}

export interface Promotion {
	id: string;
	title: string;
	description: string;
	type: PromotionTypes;
	value: number;
	date: {
		start: string;
		end: string;
	};
	limit: {
		ceiling: string;
		maximum: string;
		frequency: string;
		usageCount: number;
		minimumOrder: string;
	};
	stores: string[];
	items: string[];
	gateways: string[];
	providers: string[];
	reference: Record<string, string>;
	createdAt: string;
	updatedAt: string;
	isActive: boolean;
	isRunning: boolean;
	preferences: {
		firstTime: boolean;
	};
}

export enum PromotionTypes {
	// 'BOGOF' = 'BOGOF',
	'CASHBACK' = 'CASHBACK',
	// 'DELIVERY' = 'DELIVERY',
	'FLAT_OFF_ALL' = 'FLAT_OFF_ALL',
	'FLAT_OFF_ITEM' = 'FLAT_OFF_ITEM',
	'PERCENTAGE_OFF_ALL' = 'PERCENTAGE_OFF_ALL',
	'PERCENTAGE_OFF_ITEM' = 'PERCENTAGE_OFF_ITEM',
}

export interface Payment {
	id: string;
	user: User;
	token: string;
	amount: number;
	type: PaymentTypes;
	status: PaymentStatuses;
	description: string;
	gateway: string;
	country: Country;
	data: any;
	gatewayInit: any;
	gatewayHook: any;
	createdAt: string;
	updatedAt: string;
	operation: PaymentOperations;
	order?: Pick<Order, 'id'>;
}

export enum PaymentStatuses {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
}

export enum PaymentTypes {
	ORDER = 'ORDER',
	WALLET = 'WALLET',
}

export enum PaymentOperations {
	ADD = 'ADD',
	SUBTRACT = 'SUBTRACT',
}

export enum OrderPaymentTypes {
	ADVANCE = 'ADVANCE',
	DELIVERY = 'DELIVERY',
	WALLET = 'WALLET',
}

export enum OrderOrigins {
	'REPDASH' = 'REPDASH',
	'GLOVO' = 'GLOVO',
	'CHOWDECK' = 'CHOWDECK',
}

export enum CodeChannels {
	SMS = 'SMS',
	EMAIL = 'EMAIL',
}
